var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_224_1371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25 6.375H23.4875C23.8368 6.37501 24.1822 6.44821 24.5014 6.58988C24.8207 6.73155 25.1067 6.93854 25.3411 7.19752C25.5754 7.45649 25.7529 7.7617 25.8621 8.09347C25.9713 8.42524 26.0098 8.77621 25.975 9.12375L25.225 16.6238C25.1633 17.2406 24.8746 17.8126 24.415 18.2286C23.9553 18.6446 23.3575 18.875 22.7375 18.875H10.8C10.2218 18.8752 9.66147 18.6751 9.21431 18.3086C8.76714 17.9421 8.46082 17.4319 8.3475 16.865L6.25 6.375Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 6.375L5.2375 2.32125C5.16979 2.05094 5.01369 1.81101 4.79401 1.63957C4.57433 1.46813 4.30366 1.37501 4.025 1.375H2.5M10 23.875H12.5M20 23.875H22.5",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_224_1371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 24.75,
    fill: "white",
    transform: "translate(0 0.625)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.30d6153739b6d1984bf5540ebc8a177c.svg";
export { ForwardRef as ReactComponent };